import { render, staticRenderFns } from "./cuenta.vue?vue&type=template&id=79cc6797&scoped=true&"
import script from "./cuenta.vue?vue&type=script&lang=js&"
export * from "./cuenta.vue?vue&type=script&lang=js&"
import style0 from "./cuenta.vue?vue&type=style&index=0&id=79cc6797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc6797",
  null
  
)

export default component.exports